import React from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import LanguageSwitcher from './LanguageSwitcher';
import { appTheme } from '../styles/theme';

const FLOATING_ROUTES = new Set(['/preview', '/edit']);

const Wrap = styled.div`
  position: fixed;
  z-index: 100;
  left: 12px;
  bottom: 24px;
`;

const Switcher = styled(LanguageSwitcher)`
  box-shadow: ${appTheme.shadowMd};
  backdrop-filter: blur(12px);
  background: rgba(250, 250, 248, 0.94);
`;

/** Language picker on routes that hide the main header. */
const FloatingLanguageSwitcher: React.FC = () => {
  const { pathname } = useLocation();

  if (!FLOATING_ROUTES.has(pathname)) {
    return null;
  }

  return (
    <Wrap>
      <Switcher compact />
    </Wrap>
  );
};

export default FloatingLanguageSwitcher;
